import * as actions from './slice'
export const initiatePayment = {
  eventName: 'subscriptionInitiatePayment',
  onSuccess: [{ action: actions.setPaymentResponse, redux: true }],
  onError: [
    { action: actions.setPaymentResponse, redux: true }
  ]
}
